import type { SnackbarOrigin } from 'notistack';

// Duration constants
export const AUTO_HIDE_DURATION = 5000; // 5 seconds
export const AUTO_HIDE_DURATION_DEFAULT = 3000; // 3 seconds
export const MAX_SNACK = 5;

// Snackbar position
export const ANCHOR_ORIGIN: SnackbarOrigin = {
    vertical: 'top',
    horizontal: 'right',
} as const;

// Snackbar severity types
export const SNACKBAR_SEVERITY = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
} as const;